import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngxs/store';
import { MarkdownService } from 'ngx-markdown';
import { Loader } from './features/core/components/loader/loader';
import { AppSelectors } from './state/app.selectors';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Loader],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected readonly title = signal('1gnius');
  private store = inject(Store);
  showLoader$ = this.store.selectSignal(AppSelectors.showLoader);
  constructor(private markdownService: MarkdownService) {
    try {
      this.setMarkdownLinkConfig();
    } catch (error) {
      console.error('Markdown link renderer was not installed', error);
    }
  }

  setMarkdownLinkConfig(): void {
    const renderer = this.markdownService.renderer;
    renderer.link = (link) => {
      const target = link.href.startsWith('http') ? ' target="_blank" rel="noopener"' : '';
      const title = link.title ? ` title="${link.title}"` : '';
      return `<a href="${link.href}"${title}${target}>${link.text}</a>`;
    };
  }
}
